import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const StudentStudyQualitySummary = (props) => (
  <KpiSummary
    title="Study Quality"
    isLoading={props.isLoading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    standardDeviationValue={props.standardDeviationValue}
    formatter={props.formatter}
  />
);

StudentStudyQualitySummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

StudentStudyQualitySummary.defaultProps = {
  isLoading: false,
};

export default StudentStudyQualitySummary;
